module.exports = __webpack_public_path__ + "media/images/sns/instagram_icon-afac8448aec704bc200f2201682cab1d.png";